import { z } from 'zod';

export const ppmPreDraftSchema = z.object({
  acId: z.number({ required_error: "L'autorité contractante est obligatoire" }),
  annee: z
    .string({ required_error: "L'année est obligatoire" })
    .min(4, "L'année doit contenir 4 chiffres")
    .max(4, "L'année doit contenir 4 chiffres"),
});
